import React, { useEffect, useState } from "react";
import logo from '../../assets/pics/logoMain.svg'
import { useLocation, useNavigate } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi2";
import { TbUserCog } from "react-icons/tb";
import { MdOutlineHomeWork, MdOutlineArticle, MdOutlineMarkEmailUnread, MdWorkspacePremium, MdOutlinePushPin } from "react-icons/md";
import { IoTicketOutline } from "react-icons/io5";
import { SiHomeassistant } from "react-icons/si";
import { FaUserShield } from "react-icons/fa";


const Sidebar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();


  const navItems = [
    {
      to: "/allusers",
      label: "Vendors",
      icon: <TbUserCog />,
    },
    {
      to: "/paid-vendors",
      label: "Paid Vendors",
      icon: <MdWorkspacePremium />,
    },
    {
      to: "/venue-table",
      label: "Venues",
      icon: <MdOutlineHomeWork />,
    },
    {
      to: "/pinned-listings",
      label: "Pinned Listings",
      icon: <MdOutlinePushPin />,
    },
    {
      to: "/customers",
      label: "Customers",
      icon: <HiOutlineUsers />,
    },
    {
      to: "/enquiries-vendor",
      label: "Enquiries - Vendor",
      icon: <IoTicketOutline />
    },
    {
      to: "/enquiries-venue",
      label: "Enquiries - Venue",
      icon: <SiHomeassistant />
    },
    {
      to: "/blogs",
      label: "Blogs",
      icon: <MdOutlineArticle />,
      // condition: ["SUPER_ADMIN", "ADMIN"].includes(localStorage.getItem("role"))

    },
    {
      to: "/users",
      label: "Users",
      icon: <FaUserShield />,
      // condition: ["SUPER_ADMIN", "ADMIN"].includes(localStorage.getItem("role"))
    },
    {
      to: "/contact-us",
      label: "Contact Us Requests",
      icon: <MdOutlineMarkEmailUnread />,
    },
  ];

  return (
    <div className="min-h-screen top-0 left-0 h-full w-full bg-gray-50 border-r shadow-md">
      <div className="p-4 hidden md:flex flex-col items-start w-full justify-center">
        {/* <img src={logo} alt="Logo" className="cursor-pointer h-20 bg-white" /> */}
        <nav className="mt-10 md:mt-24 w-full">
          <ul className="space-y-2">
            {navItems.map(
              ({ to, label, icon, condition = true }) =>
                condition && (
                  <li key={to}>
                    <div
                      role="button"
                      onClick={() => navigate(to)}
                      style={{
                        backgroundColor:
                          location.pathname === to ? props.colour.backgroundcolour : "",
                        marginRight: "7px",
                        borderRadius: "9px",
                      }}
                      className="flex items-center px-4 py-2 text-gray-700 hover:bg-primary8 hover:text-primary hover:rounded-lg"
                    >
                      <div
                        className="text-xl"
                        style={{
                          color:
                            location.pathname === to ? props.colour.colour : "#B0B0B0",
                        }}
                      >
                        {icon}
                      </div>
                      <span
                        className="ml-3"
                        style={{
                          color:
                            location.pathname === to ? props.colour.colour : "",
                        }}
                      >
                        {label}
                      </span>
                    </div>
                  </li>
                )
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
